<div  style="margin-top: 15px; min-width:800px ">
  @for (item of einschaetzung; track item; let i = $index) {
    <div>
      <mat-expansion-panel #panSearchPolice class='pasuraMat1 mat-elevation-z4'  style='margin-top:20px; min-width: 800px;'  [expanded]="i==0">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Einschätzung-ID {{item.EinschaetzungID}} &nbsp;&nbsp;&nbsp;&nbsp;{{item.TimeStamp}}
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <table style="max-width: 800px">
          <tr  [class.rowGray]="getRowGrey(false)"  height="30px" >
            <th class="tabContentLeft1" ><b>Eingeschätztes Pferd</b></th>
            <th class="tabContentRight2" style="cursor: pointer"  > @if (item.Daten.gangbild_schritt !=undefined) {
              <mat-icon  (click)="getEinschaetzungPDF(item.EinschaetzungID)">picture_as_pdf</mat-icon>
            }   </th>
          </tr>
          
          @if (item.Daten.name!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Name:</th>
              <th class="tabContentLeft2" >{{item.Daten.name}}</th>
            </tr>
          }
          
          
          @if (item.Daten.geburt_datum!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Geburtsdatum:</th>
              <th class="tabContentLeft2" >{{item.Daten.geburt_datum}}</th>
            </tr>
          }
          
          @if (item.Daten.rasse!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Rasse:</th>
              <th class="tabContentLeft2" >{{item.Daten.rasse}}</th>
            </tr>
          }
          
          @if (item.Daten.farbe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Farbe:</th>
              <th class="tabContentLeft2" >{{item.Daten.farbe}}</th>
            </tr>
          }
          
          @if (item.Daten.hoehe_in_cm!=undefined && getNumber(item.Daten.hoehe_in_cm)>0 ) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Höhe:</th>
              <th class="tabContentLeft2" >{{item.Daten.hoehe_in_cm}} cm</th>
            </tr>
          }
          
          @if (item.Daten.geschlecht!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Geschlecht:</th>
              <th class="tabContentLeft2" >{{item.Daten.geschlecht}}</th>
            </tr>
          }
          @if ((item.Daten.geschlecht.startsWith('S') && item.Daten.traechtig!=undefined  && item.Daten.traechtig.length>0) ||  (item.Daten.traechtig!=undefined  && item.Daten.traechtig=='Ja') ) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Trächtig:</th>
              <th class="tabContentLeft2" >{{item.Daten.traechtig}}</th>
            </tr>
          }
          @if (item.Daten.traechtig_datum!=undefined && item.Daten.traechtig_datum.length>0) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Trächtig Datum:</th>
              <th class="tabContentLeft2" >{{item.Daten.traechtig_datum}}</th>
            </tr>
          }
          @if (item.Daten.korrekt_geimpft!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >korrekt geimpft:</th>
              <th class="tabContentLeft2" >{{item.Daten.korrekt_geimpft}}</th>
            </tr>
          }
          @if (item.Daten.entwurmung_datum!=undefined) {
            <tr [class.rowGray]="getRowGrey()" >
              <th class="tabContentLeft1" >Datum letzte Entwurmung:</th>
              <th class="tabContentLeft2" >{{item.Daten.entwurmung_datum}}</th>
            </tr>
          }
          @if (item.Daten.allgemeinzustand!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >{{item.Daten.gangbild_schritt!=undefined?"Gesamteindruck / Pflege":"Allgemeinzustand:"}}</th>
              <th class="tabContentLeft2" >{{item.Daten.allgemeinzustand}}</th>
            </tr>
          }
          <tr  [class.rowGray]="getRowGrey(false)"  height="30px" >
            <th class="tabContentLeft1" ><b>Nutzungsart</b></th>
            <th class="tabContentLeft2" ></th>
          </tr>
          @if (item.Daten.nutzungsart!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Nutzungsart:</th>
              <th class="tabContentLeft2" >{{item.Daten.nutzungsart}}</th>
            </tr>
          }
          @if (item.Daten.nutzungsart_beschreibung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Nutzungsart Beschreibung:</th>
              <th class="tabContentLeft2" >{{item.Daten.nutzungsart_beschreibung}}</th>
            </tr>
          }
          <tr  [class.rowGray]="getRowGrey(false)"  height="30px" >
            <th class="tabContentLeft1" ><b>Vorbericht</b></th>
            <th class="tabContentLeft2" ></th>
          </tr>
          @if (item.Daten.vorbericht!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Vorbericht:</th>
              <th class="tabContentLeft2" >{{item.Daten.vorbericht}}</th>
            </tr>
          }
          @if (item.Daten.fruehere_erkrankungen!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1 " >Frühere Erkrankungen:</th>
              <th class="tabContentLeft2 " >{{item.Daten.fruehere_erkrankungen}}</th>
            </tr>
          }
          <tr  [class.rowGray]="getRowGrey(false)"  height="30px" >
            <th class="tabContentLeft1" ><b>Klinische Untersuchung</b></th>
            <th class="tabContentLeft2" ></th>
          </tr>
          @if (item.Daten.herkunftsland!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Herkunftsland:</th>
              <th class="tabContentLeft2" >{{item.Daten.herkunftsland}}</th>
            </tr>
          }
          @if (item.Daten.import_datum!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Import Datum:</th>
              <th class="tabContentLeft2" >{{item.Daten.import_datum}}</th>
            </tr>
          }
          @if (item.Daten.naehrzustand!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Nährzustand:</th>
              <th class="tabContentLeft2" >{{item.Daten.naehrzustand}}</th>
            </tr>
          }
          @if (item.Daten.charakter!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Charakter:</th>
              <th class="tabContentLeft2" >{{item.Daten.charakter}}</th>
            </tr>
          }
          @if (item.Daten.haarkleid!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Haut/Haarkleid:</th>
              <th class="tabContentLeft2" >{{item.Daten.haarkleid}}</th>
            </tr>
          }
          @if (item.Daten.sommerekzem!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Sommerekzem:</th>
              <th class="tabContentLeft2" >{{item.Daten.sommerekzem}}</th>
            </tr>
          }
          @if (item.Daten.augen!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Augen:</th>
              <th class="tabContentLeft2" > <span [innerHtml]="item.Daten.augen"></span>  </th>
            </tr>
          }
          @if (item.Daten.zahnstellung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Maul/Zahnstellung:</th>
              <th class="tabContentLeft2" >{{item.Daten.zahnstellung}}</th>
            </tr>
          }
          @if (item.Daten.verdauung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Verdauung:</th>
              <th class="tabContentLeft2" >{{item.Daten.verdauung}}</th>
            </tr>
          }
          @if (item.Daten.kotwasser!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Kotwasser:</th>
              <th class="tabContentLeft2" >{{item.Daten.kotwasser}}</th>
            </tr>
          }
          <tr  [class.rowGray]="getRowGrey(false)"  height="30px" >
            <th class="tabContentLeft1" ><b>Untersuchung Bewegungsapparat</b></th>
            <th class="tabContentLeft2" ></th>
          </tr>
          @if (item.Daten.gang!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Gang:</th>
              <th class="tabContentLeft2" >{{item.Daten.gang}}</th>
            </tr>
          }
          @if (item.Daten.gangbild_schritt!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Gangbild Schritt:</th>
              <th class="tabContentLeft2" >{{item.Daten.gangbild_schritt}}</th>
            </tr>
          }
          @if (item.Daten.gangbild_trab!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Gangbild Trab:</th>
              <th class="tabContentLeft2" >{{item.Daten.gangbild_trab}}</th>
            </tr>
          }
          @if (item.Daten.wendungen_links!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Wendungen links:</th>
              <th class="tabContentLeft2" >{{item.Daten.wendungen_links}}</th>
            </tr>
          }
          @if (item.Daten.wendungen_rechts!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Wendungen rechts:</th>
              <th class="tabContentLeft2" >{{item.Daten.wendungen_rechts}}</th>
            </tr>
          }
          @if (item.Daten.beschlaege!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Hufe/Beschlag:</th>
              <th class="tabContentLeft2" >{{item.Daten.beschlaege}}</th>
            </tr>
          }
          @if (item.Daten.zangenprobe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Zangenprobe:</th>
              <th class="tabContentLeft2" >{{item.Daten.zangenprobe}}</th>
            </tr>
          }
          @if (item.Daten.beugeprobe_vorne!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Beugeprobe vorne:</th>
              <th class="tabContentLeft2" >{{item.Daten.beugeprobe_vorne}}</th>
            </tr>
          }
          @if (item.Daten.beugeprobe_hinten!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Beugeprobe hinten:</th>
              <th class="tabContentLeft2" >{{item.Daten.beugeprobe_hinten}}</th>
            </tr>
          }
          @if (item.Daten.brettprobe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Brettprobe:</th>
              <th class="tabContentLeft2" >{{item.Daten.brettprobe}}</th>
            </tr>
          }
          @if (item.Daten.sehnen!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Sehnen:</th>
              <th class="tabContentLeft2" >{{item.Daten.sehnen}}</th>
            </tr>
          }
          @if (item.Daten.sehnen_bein!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >betroffenes Bein:</th>
              <th class="tabContentLeft2" >{{item.Daten.sehnen_bein}}</th>
            </tr>
          }
          @if (item.Daten.ruecken!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Rücken:</th>
              <th class="tabContentLeft2" >{{item.Daten.ruecken}}</th>
            </tr>
          }
          @if (item.Daten.strahlbeine!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Strahlbeine:</th>
              <th class="tabContentLeft2" >{{item.Daten.strahlbeine}}</th>
            </tr>
          }
          <tr  [class.rowGray]="getRowGrey(false)"  height="30px" >
            <th class="tabContentLeft1" ><b>Belastungsuntersuchung</b></th>
            <th class="tabContentLeft2" ></th>
          </tr>
          @if (item.Daten.herz_ruhe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Herz Ruhe:</th>
              <th class="tabContentLeft2" >{{item.Daten.herz_ruhe}}</th>
            </tr>
          }
          @if (item.Daten.herz_belastung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Herz Belastung:</th>
              <th class="tabContentLeft2" >{{item.Daten.herz_belastung}}</th>
            </tr>
          }
          @if (item.Daten.jugularvenen_ruhe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Jugularvenen in Ruhe:</th>
              <th class="tabContentLeft2" >{{item.Daten.jugularvenen_ruhe}}</th>
            </tr>
          }
          @if (item.Daten.jugularvenen_belastung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Jugularvenen nach Belastung:</th>
              <th class="tabContentLeft2" >{{item.Daten.jugularvenen_belastung}}</th>
            </tr>
          }
          @if (item.Daten.herzauskultation_ruhe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Herzauskultation in Ruhe:</th>
              <th class="tabContentLeft2" >{{item.Daten.herzauskultation_ruhe}}</th>
            </tr>
          }
          @if (item.Daten.herzauskultation_belastung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Herzauskultation nach Belastung:</th>
              <th class="tabContentLeft2" >{{item.Daten.herzauskultation_belastung}}</th>
            </tr>
          }
          @if (item.Daten.lungenauskultation_ruhe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Lungenauskultation Ruhe:</th>
              <th class="tabContentLeft2" >{{item.Daten.lungenauskultation_ruhe}}</th>
            </tr>
          }
          @if (item.Daten.lungenauskultation_belastung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Lungenauskultation nach Belastung:</th>
              <th class="tabContentLeft2" >{{item.Daten.lungenauskultation_belastung}}</th>
            </tr>
          }
          @if (item.Daten.nasenausfluss!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Nasenausfluss:</th>
              <th class="tabContentLeft2" >{{item.Daten.nasenausfluss}}</th>
            </tr>
          }
          @if (item.Daten.nasenausfluss_ruhe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Nasenausfluss Ruhe:</th>
              <th class="tabContentLeft2" >{{item.Daten.nasenausfluss_ruhe}}</th>
            </tr>
          }
          @if (item.Daten.nasenausfluss_belastung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Nasenausfluss nach Belastung:</th>
              <th class="tabContentLeft2" >{{item.Daten.nasenausfluss_belastung}}</th>
            </tr>
          }
          @if (item.Daten.husten!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Husten:</th>
              <th class="tabContentLeft2" >{{item.Daten.husten}}</th>
            </tr>
          }
          @if (item.Daten.husten_ruhe!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Husten Ruhe:</th>
              <th class="tabContentLeft2" >{{item.Daten.husten_ruhe}}</th>
            </tr>
          }
          @if (item.Daten.husten_belastung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Husten nach Belastung:</th>
              <th class="tabContentLeft2" >{{item.Daten.husten_belastung}}</th>
            </tr>
          }
          @if (item.Daten.haltungsform!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Haltungsform:</th>
              <th class="tabContentLeft2" >{{item.Daten.haltungsform}}</th>
            </tr>
          }
          @if (item.Daten.pflege!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Pflege:</th>
              <th class="tabContentLeft2" >{{item.Daten.pflege}}</th>
            </tr>
          }
          <tr  [class.rowGray]="getRowGrey(false)"  height="30px" >
            <th class="tabContentLeft1" ><b>Aufnahme</b></th>
            <th class="tabContentLeft2" ></th>
          </tr>
          @if (item.Daten.aufnahme!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Aufnahme:</th>
              <th class="tabContentLeft2" >{{item.Daten.aufnahme}}</th>
            </tr>
          }
          @if (item.Daten.begruendung!=undefined) {
            <tr [class.rowGray]="getRowGrey()">
              <th class="tabContentLeft1" >Begründung:</th>
              <th class="tabContentLeft2" >{{item.Daten.begruendung}}</th>
            </tr>
          }
        </table>
        <mat-divider style="margin-top:10px ; width=90%"></mat-divider>
        <br>
          @if (antrag!=undefined) {
            <div>
              <mat-form-field class="FormData">
                <mat-label>Bemerkungen/Vorbehalt</mat-label>
                <textarea matInput placeholder="Bemerkungen/Vorbehalt" [(ngModel)]="antrag.Vorbehalt"  ></textarea>
              </mat-form-field>
              <button
                [disabled]="antrag.Vorbehalt==vorbehaltOrg"
                mat-flat-button	color="primary"  (click)="saveBemerkung()"
                style="width: 90%; margin-top: 5px;">
                Bemerkung speichern
              </button>
            </div>
          }
        </mat-expansion-panel>
      </div>
    }
  </div>
